export function buildQuery(params: Record<string, any>): string {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value.toString());
    }
  });

  return query.toString();
}

export function buildQueryV2(params: Record<string, any>): string {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      // NEW: Check if the value is an array
      if (Array.isArray(value)) {
        // Append each item in the array separately using the same key
        value.forEach((item) => {
          if (item !== undefined && item !== null && item !== "") {
            query.append(key, item.toString());
          }
        });
      } else {
        // Original logic for standard strings, numbers, booleans
        query.append(key, value.toString());
      }
    }
  });

  return query.toString();
}